// Constants
import { FILE_ARRAY_BUFFER_TYPE, FILE_ARRAY_OPTIONS, UNNAMED_FILE_NAME } from './constants/files-blob.constants';
// Utilities
import { wasSuccessRequest } from '../../../utilities/http/http.utils';
const onLoadBlobFn = ({ callback, xhr }) => {
    const status = xhr?.status || xhr?.currentTarget?.status || 500;
    if (wasSuccessRequest(status)) {
        const blob = xhr.response || xhr?.currentTarget?.response || new Blob();
        callback(new Blob([blob], FILE_ARRAY_BUFFER_TYPE));
    }
    else {
        throw new Error('Error loading blob');
    }
};
const downloadFileAsBlob = ({ url, callback }) => {
    const xhr = new XMLHttpRequest();
    xhr.open('get', url, true);
    xhr.responseType = FILE_ARRAY_OPTIONS;
    xhr.onload = (xhrProp) => onLoadBlobFn({ callback, xhr: xhrProp || xhr });
    xhr.send();
    return xhr;
};
const createObjectUrlFromBlob = (blob) => window.URL.createObjectURL(blob);
const fileIsBlobType = (blob) => typeof blob === 'object' && blob instanceof Blob;
const createTagAndsDispatchFile = ({ blob, filename }) => {
    const a = document.createElement('a');
    a.href = createObjectUrlFromBlob(blob);
    a.download = filename || UNNAMED_FILE_NAME;
    document?.body?.appendChild(a);
    a.click();
    a.remove();
};
const downloadFileFromUrl = ({ filename = UNNAMED_FILE_NAME, url }) => downloadFileAsBlob({
    url,
    callback: (blob) => createTagAndsDispatchFile({ blob, filename }),
});
export { createObjectUrlFromBlob, createTagAndsDispatchFile, downloadFileFromUrl, downloadFileAsBlob, fileIsBlobType };
//# sourceMappingURL=file-blobs.utils.js.map